import { useSnapshot } from 'valtio'
import { useNavigate } from 'react-router-dom'

import styles from './index.module.less'
import { message } from '@/App'
import { chatState, chatAction, configState } from '@/store'
import StarSvg from '@/assets/images/icon/hot-left-title.svg?react'

import { SessionStatuTypes, RoleTypes } from '@/constants'
import ChatInputArea from '@/components/ChatInputArea'
import InteractiveChatInputArea from '@/components/ChatInputArea/Interactive'
import {
  TOOL_PPT_ICON,
  TOOL_TRANS_ICON,
  TOOL_SEARCH_ICON,
  TOOL_PROMPT_ICON,
} from './icon'

const ChatTrigger = () => {
  const { sessionStatu, interactiveMode } = useSnapshot(chatState)
  const navigator = useNavigate()

  const onSend = () => {
    const text = chatState.inputText.trim()
    if (chatState.inputFileList.find(i => !i.serverUrl)) {
      message.open({
        key: 'chat',
        type: 'error',
        content: '请等待文件上传完成',
      })
      return
    }
    if (!chatState.inputFileList.length && !text) {
      message.open({
        key: 'chat',
        type: 'error',
        content: '请输入问题',
      })
      return
    }

    let sendData = {
      question_id: chatState.asrSessionId,
      use_asr: chatState.asrSessionId ? 1 : 0,
      edit_asr: chatState.edit_asr,
      text,
    } as any

    if (chatState.inputFileList.length) {
      if (chatState.inputFileType === 'doc') {
        const sendfile = chatState.inputFileList[0]
        sendData = {
          ...sendData,
          doc: {
            filename: sendfile.name,
            filesize: sendfile.size,
            fileurl: sendfile.serverUrl,
            fileid: sendfile.serverId,
          },
        }
      } else {
        sendData = {
          ...sendData,
          [chatState.inputFileType]: chatState.inputFileList
            .map(i => i.serverUrl)
            .join(','),
        }
      }
    }

    chatAction.onUserSubmit(sendData)
    chatState.inputFileType = ''
    chatState.inputFileList = []
    chatState.asrSessionId = ''
    chatState.inputText = ''
  }

  const onStop = () => {
    const messages = chatState.sessionMessages
    let lastMessage = messages.findLast(item => item.role === RoleTypes.user)
    chatAction.closeConnect(lastMessage?.question_id || null)
  }

  const tools = [
    {
      title: 'PPT生成',
      icon: TOOL_PPT_ICON,
      action: () => {
        // navigator('/appSet/pptGenerate')
        window.open('/#/appSet/pptGenerate', '_blank', 'noreferrer')
      },
    },
    {
      title: '中英互译',
      icon: TOOL_TRANS_ICON,
      action: () => {
        // navigator('/appSet/academicTrans')
        window.open('/#/appSet/academicTrans', '_blank', 'noreferrer')
      },
    },
    {
      title: '学术搜索',
      icon: TOOL_SEARCH_ICON,
      action: () => {
        // navigator('/appSet/search')
        window.open('/#/appSet/search', '_blank', 'noreferrer')
      },
    },
    {
      title: '指令中心',
      icon: TOOL_PROMPT_ICON,
      action: () => {
        configState.showPromptModal = !configState.showPromptModal
      },
    },
  ]

  return (
    <div className="px-4 md:px-7">
      <div className={styles.chatTriggerWrap}>
        <div className="h-6 absolute inset-0 -top-5 bg-gradient-to-b from-white/50 to-white blur-sm -z-[1] hidden md:block"></div>
        {!interactiveMode && (
          <div className="gap-2 pb-2 hidden lg:flex text-xs">
            <div
              className="px-3 h-7 border border-[#1C1F231A] rounded-full flex gap-1 justify-center items-center cursor-pointer bg-gradient-to-r from-[#F2F8FE] via-[#FFF9F2] to-[#F5FBF5]"
              onClick={() => {
                chatState.interactiveMode = true
              }}
            >
              <span className="bg-gradient-to-r from-[#1C1F23] to-[#7572FD] bg-clip-text text-transparent">
                交互思考
              </span>
              <StarSvg className="size-4" />
            </div>
            {tools.map((item, index) => (
              <div
                key={index}
                className="px-2 h-7 border border-[#1C1F231A] rounded-full flex gap-1 justify-center items-center cursor-pointer hover:bg-[#1c1f2308]"
                onClick={item.action}
              >
                {item.icon}
                <span>{item.title}</span>
              </div>
            ))}
          </div>
        )}
        {interactiveMode ? (
          <InteractiveChatInputArea
            loading={sessionStatu === SessionStatuTypes.pending}
            onSend={onSend}
            onStop={onStop}
            className="border-2 border-content-first"
          />
        ) : (
          <ChatInputArea
            loading={sessionStatu === SessionStatuTypes.pending}
            onSend={onSend}
            onStop={onStop}
            className="border-2 border-content-first"
          />
        )}
      </div>
    </div>
  )
}

export default ChatTrigger
